import { Button } from "@mui/material";

function IncrementDonation({ isShow, incDonation }: { isShow: boolean, incDonation: () => void }) {
  return(
    isShow ? 
      <Button className="add-btn p-0 color-white" color="error" onClick={incDonation}>
        <i className="ri-add-line"></i>
      </Button>
    :
    null
  )
}

export default IncrementDonation;